module.exports = __webpack_public_path__ + "img/top5_img1.8606691f.png";